__turbopack_context__.v({
  "checkboxContainer": "-TzwWG_checkboxContainer",
});
